import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.PaymentProfileView.';

  public static readonly savePaymentProfile = `${Id.prefix}savePaymentProfile`;
}

export class LangPaymentProfileView {
  private constructor() {}

  public static savePaymentProfile(): string {
    return interpolate(Id.savePaymentProfile);
  }
}

export class PaymentProfileViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.savePaymentProfile,
      "Save {{glossary 'payment-profile'}}",
      'Button label for saving a payment profile'
    );
  }
}
